import React from 'react';
import { Link } from 'react-router-dom';
import type { SearchResultCardProps } from '../interfaces';

const SearchResultCard: React.FC<SearchResultCardProps> = ({
  details,
  imageUrl,
  price,
  product,
  onResultClick,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onResultClick(product);
  };

  return (
    <div className="search-result-item">
      <Link
        to={`/products/${product.id}`}
        state={{
          selectedMaterial: product.selectedMaterial,
          materialPreview: product.materialPreview,
        }}
        className="search-result-card"
        onMouseDown={handleClick}
        onClick={handleClick}
      >
        {imageUrl ? (
          <img src={imageUrl} alt={product.title} className="card-image-search" />
        ) : (
          <span className="card-image-search card-image-search--empty">TK</span>
        )}
        <div className="card-content">
          <h3>{product.title}</h3>
          {details.length > 0 && <p>{details.join(' · ')}</p>}
        </div>
        {price && <span className="card-price">{price}</span>}
      </Link>
    </div>
  );
};

export default React.memo(SearchResultCard);
